export default __webpack_public_path__ + "static/media/zoomOut.de8f3215.svg";